import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import { get_driver_list } from "../../redux/driverSlice";
import {
  Box,
  Button,
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const DriverList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(10);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Added for search input
  const { driver_list, total_driver_count,loading } = useSelector(
    (state) => state.drivers
  );

  const location = useLocation();

  useEffect(() => {
    const savedPage = location.state?.page || 1;
    const savedRows = location.state?.rows || 5;

    setpage(savedPage);
    setRows(savedRows);
    setInitialValue((savedPage - 1) * savedRows + 1);

    store.dispatch(get_driver_list({ page: savedPage, rows: savedRows }));
  }, []);

  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_driver_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_driver_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_driver_count || setpage(page + 1);
    rows * page >= total_driver_count ||
      store.dispatch(get_driver_list({ page: page + 1, rows: rows }));
  };

  // ✅ Filter drivers by name or mobile
  const filteredDrivers = driver_list.filter((driver) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      driver.name?.toLowerCase().includes(lowerSearch) ||
      driver.mobile1?.toLowerCase().includes(lowerSearch)
    );
  });

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        flexWrap="wrap"
        w="100%"
        mb={4}
      >
        <Flex
          justifyContent="space-between"
          alignItems="center"
          w="100%"
          flexWrap="wrap"
          direction={["column", "column", "row"]}
          gap={4}
        >
          {/* Left: Heading */}
          <Heading fontSize="xl">Drivers List</Heading>

          {/* Right: Select, Input, Button */}
          <Flex
            alignItems="center"
            gap={3}
            flexWrap="wrap"
            direction={["column", "column", "row"]}
            w={["100%", "auto"]}
          >
            <Select
              placeholder=""
              size="md"
              value={rows}
              onChange={(e) => {
                store.dispatch(
                  get_driver_list({ page: page, rows: e.target.value })
                );
                setRows(e.target.value);
              }}
              w={["100%", "80px"]}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>

            {/* ✅ Search input (name & number) */}
            <InputGroup
              bg="#f4f5f7"
              borderRadius={5}
              maxW="sm"
              w={["100%", "auto"]}
            >
              <Input
                placeholder="Search by name or number..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <InputRightElement>
                <FiSearch />
              </InputRightElement>
            </InputGroup>

            <button
              style={{
                backgroundColor: "#007bc9",
                color: "white",
                padding: "8px 16px",
                borderRadius: "5px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() =>
                navigate("/driver-list/add-driver", {
                  state: {
                    page,
                    rows,
                  },
                })
              }
            >
              + Add Driver
            </button>
          </Flex>
        </Flex>
      </Card>

      {loading ? (<GasCylinderLoader size="sm" loadingText="Loading Dp List"/>):(
  <>
        {/* ✅ Render filtered list */}
        <SimpleGrid minChildWidth="xs" spacing="10px">
        {filteredDrivers.length > 0 ? (
          filteredDrivers.map((el, i) => (
            <Card
              key={el.id}
              paddingInline={5}
              paddingBlock={2}
              cursor="pointer"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              _hover={{ boxShadow: "md", transform: "translateY(-3px)" }}
              transition="all 0.2s ease"
              onClick={() =>
                navigate("/driver-list/driver-detail", {
                  state: {
                    id: el.id,
                    page,
                    rows,
                  },
                })
              }
            >
              {/* Header: Name + UUID */}
              <Flex justify="space-between" mb={2}>
                <DisplayData
                  fs="16px"
                  v_color="#007bc9"
                  fw="bold"
                  value={el.name || "NA"}
                />
                <DisplayData v_color="#f37022" fw="bold" value={el.uuid || "NA"} />
              </Flex>

              {/* Details */}
              <Box mt={1}>
                {[
                  { title: "Mobile", value: el.mobile1 },
                  { title: "Email", value: el.email },
                  { title: "Aadhar", value: el.aadhaar },
                  { title: "Pan", value: el.pan },
                  { title: "Status", value: "Not Verified", v_color: "#000" },
                ].map((item, idx) => (
                  <Flex
                    key={idx}
                    justify="space-between"
                    align="center"
                    mb="1"
                    wrap="nowrap"
                  >
                    <Text fontSize="sm" color="gray.600" flex="1" noOfLines={1}>
                      {item.title}
                    </Text>
                    <Text
                      fontSize="sm"
                      color={item.v_color || "gray.800"}
                      flex="1"
                      textAlign="right"
                      noOfLines={1}
                      fontWeight={item.fw === "bold" ? "bold" : "normal"}
                    >
                      {item.value || "NA"}
                    </Text>
                  </Flex>
                ))}
              </Box>
            </Card>
          ))
        ) : (
          <Text textAlign="center" color="gray.500">
            No drivers found.
          </Text>
        )}
      </SimpleGrid>

      {/* Pagination */}
      <Card
        alignItems={"center"}
        alignSelf={"end"}
        gap={3}
        flexDirection={"row"}
      >
        <FiChevronLeft
          cursor={"pointer"}
          color={page == 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />
        <Flex gap={3}>
          <Text>{initialValue}</Text>-
          <Text>
            {rows * page >= total_driver_count
              ? total_driver_count
              : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_driver_count}</Text>
        </Flex>
        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_driver_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>
  </>
)}

    </>
  );
};

export default DriverList;
